import {definePlugin} from 'sanity'

import coordsSearchComponent from './components/get-coords'

export const getCoordinates = definePlugin<void>(() => {
  return {
    schema: {
      types: [
        {
          name: 'coordinates',
          title: 'Coordinates Search',
          description: 'Enter an address below. More details, better the result will be.',
          type: 'geopoint',
          components: {input: coordsSearchComponent},
        },
      ],
    },
  }
})
